/* eslint-disable */
export default {
  noResultFoundFor: 'Nessun risultato per',
  foundFromServerHint:
    'Digita la parola chiave e premi INVIO per cercare in {appName}',
  notResultFoundFromServer: 'Nessun risultato trovato',
  loading: 'caricamento...',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"foundFromServerHint"@#@ @source: @#@"Type keyword and press Enter to search in {appName}"@#@
// @key: @#@"notResultFoundFromServer"@#@ @source: @#@"No results found"@#@
// @key: @#@"loading"@#@ @source: @#@"loading..."@#@
